<template>
    <transition name="fade-scale">

        <div class="brt-loading-module" v-show="visible">

            <div class="wrap">

                <i class="iconfont icon-jiazai"></i>

                <span>{{loadTip}}</span>

            </div>

        </div>

    </transition>

</template>

<script>
    export default {
        name: "loading",
        data(){
            return {
                visible:false,
                loadTip:'正在加载中~~~'
            }
        }
    }
</script>

<style lang="less">

    @import "../../styles/transition";
    @import "../../styles/cssBlock";

    .brt-loading-module{

        .absoluteByCover();
        color: @themeReverseColor;
        background-color: @maskBgColor;
        font-size: @normalFontSize;

        display: flex;
        justify-content: center;
        align-items: center;

        >.wrap{
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            >i{
                display: inline-block;
                font-size: @100px;
                margin-bottom: @standartSpaceA1;
                animation: rotateFrames 1.5s linear infinite;
            }
        }

    }

</style>